/* eslint-disable no-plusplus */
import { createEvent, sample } from 'effector';
import type { CategoryData, SceneData } from '@types';
import addComponent from '@utils/addComponent';
import {
  $categoryList,
  $categoryMap,
  $sceneMap,
  $tourData,
} from '@stores/dataStores';
import { $isVip, $member } from '@stores/memberStores';
import PreviewModal from '../PreviewModal';

const preview = createEvent();

sample({
  source: {
    data: $tourData,
    cMap: $categoryMap,
    sMap: $sceneMap,
    cList: $categoryList,
    member: $member,
    isVip: $isVip,
  },
  clock: preview,
}).watch(({ data, cMap, cList, sMap, member, isVip }) => {
  const category: CategoryData[] = [];
  const scenes: SceneData[] = [];
  let newId = 1;
  let sort = 0;
  for (let i = 0; i < cList.length; i++) {
    const cItem = cMap.get(cList[i])!;
    const newCId = newId++;
    if (cItem.categoryIds.length) {
      const children: CategoryData[] = [];
      for (let j = 0; j < cItem.categoryIds.length; j++) {
        const subItem = cMap.get(cItem.categoryIds[j])!;
        const newSubId = newId++;
        for (let k = 0; k < subItem.sceneIds.length; k++) {
          const sceneItem = sMap.get(subItem.sceneIds[k]);
          if (sceneItem) {
            sort++;
            scenes.push({ ...sceneItem, categoryId: newSubId, sort });
          }
        }
        children.push({ id: newSubId, name: subItem.name });
      }
      category.push({ id: newCId, name: cItem.name, children });
    } else {
      for (let m = 0; m < cItem.sceneIds.length; m++) {
        const sceneItem = sMap.get(cItem.sceneIds[m]);
        if (sceneItem) {
          sort++;
          scenes.push({ ...sceneItem, categoryId: newCId, sort });
        }
      }
      category.push({ id: newCId, name: cItem.name });
    }
  }

  addComponent((remove) => (
    <PreviewModal
      panoData={{
        name: data.name!,
        remark: data.remark!,
        keywords: data.keywords ?? '',
        selected: 0,
        thumbUrl: data.thumbUrl!,
        pvCount: 0,
        likeCount: 0,
        privilege: 1,
        author: {
          uid: member.property?.uid!,
          nickname: member.property?.nickname!,
          avatar: member.property?.avatar!,
          cert: member.cert!,
          expired: member.expired!,
        },
        templateExpired: isVip ? 0 : 1,
      }}
      jsonData={{ ...data, category, scenes }}
      onRequestClose={remove}
    />
  ));
});

export default preview;
